module.exports = __webpack_public_path__ + "img/fujian.f8a47f8d.png";